import React from 'react'
import './style.css'
import Corretor from './corretor/container'


export default class Corretores extends React.Component{
    render(){

        console.log('class Corretores', this.props)

        let corretores = this.props.corretores.map(corretor => {
            console.log(corretor)
            return {
                corretor,
                participacoes : this.props.lotes.filter(x => x.pessoa == corretor.get('usuario')).length
            }
        }).map((x,k) => <Corretor key={k} corretor={x.corretor} participacoes={x.participacoes} />)
        
        

        return(
            <div className='corretores_container_wrapper'>
                <h2 className='page_title'>Corretores</h2>

                <div className='corretores_content'>
                    {corretores}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/administrativo/corretores/component.js